const getters = {
  dictMap: state => state.dict.dictMap
}
export default getters
